import lastSyncDate from './lastSyncDate'

export default lastSyncDate
